// extracted by mini-css-extract-plugin
export default {"ganziHeader":"Ganzi_ganziHeader__dvTFD"};